const getInitials = (str, space = false) =>
    str
        .toLowerCase()
        .toUpperCase()
        .split(' ')
        .map((word) => word.charAt(0))
        .join(space ? ' ' : '');

export default getInitials;
